import React from "react";
import "./CustomerTabs.scss";
import AccountTabs from "../AccountTabs/AccountTabs";
import { Box } from "@mui/material";

function CustomerTabs({ 
  selectedUser, 
  selectedUserData, 
  setSelectedUserData, 
  setRoleChanged, 
  setProfileStatusChanged,
  updateTableStatus, 
  roleChanged, 
  handleSelectedUser,
  isAssociateAgent,
  isSuperAdmin,
  handleClose,
  tabPermissions
}) {
  return (
    <Box 
      //className="account-tabs-container"
      sx={{
        background: "white",
        borderRadius: "0 !important",
        boxShadow: "0px 1px 15px 0px rgba(0, 0, 0, 0.04)",
        maxHeight: "500px",
        '@media (min-width: 1920px)': {
          minHeight: "750px",
          // minHeight: "700px",
        },
      }}
    >
      <AccountTabs
        selectedUser={selectedUser}
        selectedUserData={selectedUserData}
        setSelectedUserData={setSelectedUserData}
        setRoleChanged={setRoleChanged}
        setProfileStatusChanged={setProfileStatusChanged}
        updateTableStatus={updateTableStatus}
        roleChanged={roleChanged}
        handleSelectedUser={handleSelectedUser}
        isAssociateAgent={isAssociateAgent}
        isSuperAdmin={isSuperAdmin}
        handleClose={handleClose}
        tabPermissions={tabPermissions}
      />
    </Box>
  );
}

export default CustomerTabs;
